import type { FileUpload } from 'graphql-upload/GraphQLUpload.js'
import GraphQLUpload from 'graphql-upload/GraphQLUpload.js'
import { Field, ID, InputType, Int, ObjectType } from 'type-graphql'

import { DataKeyItemPatch } from './data-key-item-type.js'
import { DataKeySet } from './data-key-set.js'
import { DataSetReportType } from '../data-set/data-set.js'

@InputType()
export class NewDataKeySet {
  @Field({ description: 'Name of the data key set for identification.' })
  name: string

  @Field({ nullable: true })
  description?: string

  @Field({ nullable: true })
  active?: boolean

  @Field({ nullable: true })
  reportType?: DataSetReportType

  @Field({ nullable: true })
  reportView?: string

  @Field(type => [DataKeyItemPatch], { nullable: true })
  dataKeyItems?: DataKeyItemPatch[]

  @Field(type => GraphQLUpload, { nullable: true })
  thumbnail?: FileUpload
}

@InputType()
export class DataKeySetPatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true, description: 'Description of the data key set.' })
  description?: string

  @Field({ nullable: true, description: 'Indicates if the data key set is active.' })
  active?: boolean

  @Field({ nullable: true, description: 'Type of report to generate for this key set.' })
  reportType?: DataSetReportType

  @Field({ nullable: true, description: 'Custom report view for this key set.' })
  reportView?: string

  @Field(type => [DataKeyItemPatch], {
    nullable: true,
    description: 'The key items that define the categorization structure for this key set.'
  })
  dataKeyItems?: DataKeyItemPatch[]

  @Field(type => GraphQLUpload, {
    nullable: true,
    description: 'Thumbnail image for visual representation of the key set.'
  })
  thumbnail?: FileUpload

  @Field({ nullable: true, description: 'Create/Update flag for batch operations.' })
  cuFlag?: string
}

@ObjectType({ description: 'Represents a paginated list of data key sets.' })
export class DataKeySetList {
  @Field(type => [DataKeySet], { description: 'List of data key sets.' })
  items: DataKeySet[]

  @Field(type => Int, { description: 'Total number of data key sets in the list.' })
  total: number
}
